import { render, staticRenderFns } from "./Icon.component.vue?vue&type=template&id=ac916c5a"
import script from "./Icon.component.vue?vue&type=script&lang=js"
export * from "./Icon.component.vue?vue&type=script&lang=js"
import style0 from "./Icon.component.vue?vue&type=style&index=0&id=ac916c5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports